import { render, staticRenderFns } from "./wo.vue?vue&type=template&id=3b9865b1&"
import script from "./wo.vue?vue&type=script&lang=js&"
export * from "./wo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports